import { render } from "./Dashboard.vue?vue&type=template&id=f96fcaf6&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=f96fcaf6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f96fcaf6"

export default script